const styles = {
  table: { width: `100%`, margin: `auto` },
  disabledStation: {
    backgroundColor: "#eb8888",
    color: "#f2f2f2"
  },
  tableContainer: {
    overflow: "auto",
    paddingRight: "unset",
    paddingLeft: "unset"
  },
  disabledCell: {
    backgroundColor: "#c2c2c2",
    cursor: "not-allowed"
  }
};

export default styles;
